module.exports = __webpack_public_path__ + "static/media/instagramLogo.15cf323c.png";